
  import React from "react"
  import Component from "/Users/joey.padasian/Sites/global-gallery/src/layouts/index.js"
  import data from "/Users/joey.padasian/Sites/global-gallery/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js